import { NavLink } from "react-router-dom";
import Faq from "./faq";
import { useEffect } from "react";
import { CONTACT_CONFIG } from '../config/contact';

export default function Privacy() {
  const contactInfo = CONTACT_CONFIG;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* Header Section */}
      <section className="bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white py-8">
        <div className="h-[25vh]"></div>
        <div className="main-content">
          {/* Main Title */}
          <div className="text-center">
            <h1 className="text-4xl font-bold">Privacybeleid</h1>
          </div>
          {/* Navigation Breadcrumbs */}
          <div className="text-center mb-4">
            <span className="text-sm">
              <NavLink
                to="/"
                className="transition-all duration-500 hover:text-[#090979]"
                onClick={scrollToTop}
              >
                Home
              </NavLink>{" "}
              /{" "}
              <span className="text-gray-300">
                Privacybeleid
              </span>
            </span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-slate-50 text-[#1B1B1B] py-12 min-h-[80vh]">
        <div className="main-content w-[85%] m-auto">
          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                1. Informatie die wij verzamelen
              </h2>
              <p className="text-base leading-relaxed">
                Wij verzamelen informatie die u ons rechtstreeks verstrekt,
                zoals uw naam, e-mailadres en betalingsgegevens wanneer u zich abonneert
                op onze IPTV-diensten. Deze informatie is noodzakelijk om onze diensten te leveren
                en uw betalingen te verwerken.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                2. Hoe wij uw informatie gebruiken
              </h2>
              <p className="text-base leading-relaxed">
                Wij gebruiken uw informatie om onze IPTV-diensten te leveren, te onderhouden
                en te verbeteren, uw betalingen te verwerken, met u te communiceren
                over uw account en u belangrijke updates over onze diensten te sturen.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                3. Delen van uw informatie
              </h2>
              <p className="text-base leading-relaxed">
                Wij verkopen, verhuren of verhandelen uw persoonlijke informatie
                niet aan derden. Wij kunnen uw informatie uitsluitend delen
                met onze betalingsdienstaanbieders om uw transacties te verwerken,
                en alleen voor zover noodzakelijk.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                4. Beveiliging van uw gegevens
              </h2>
              <p className="text-base leading-relaxed">
                Wij nemen passende beveiligingsmaatregelen om uw persoonlijke
                informatie te beschermen tegen ongeoorloofde toegang, wijziging,
                openbaarmaking of vernietiging. Uw gegevens worden versleuteld en veilig opgeslagen.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">5. Uw rechten</h2>
              <p className="text-base leading-relaxed">
                U heeft het recht om op elk moment toegang te vragen tot uw persoonlijke informatie,
                deze te corrigeren of te verwijderen. U kunt ook bezwaar maken tegen
                de verwerking van uw gegevens of verzoeken om overdraagbaarheid van uw gegevens.
              </p>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">6. Neem contact met ons op</h2>
              <p className="text-base leading-relaxed mb-4">
                Voor vragen over dit privacybeleid of om uw rechten uit te oefenen,
                kunt u contact met ons opnemen via:
              </p>
              <ul className="list-disc list-inside space-y-2 text-base">
                <li>E-mail: {contactInfo.email}</li>
                <li>
                  WhatsApp:{" "}
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Klik hier om contact met ons op te nemen
                  </a>
                </li>
              </ul>
            </div>

            {/* Conclusion */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-base leading-relaxed">
                Bedankt dat u voor {contactInfo.companyName} heeft gekozen. Wij zijn er trots op
                uw privacy te waarborgen en u een hoogwaardige service te bieden
                zonder uw veiligheid of anonimiteit in gevaar te brengen.
              </p>
            </div>
          </div>
        </div>
        <Faq />
      </section>
    </>
  );
}
